import antdEN from 'antd/locale/en_US';
import { importAllJsonFiles } from '../../../utils/utilities';

const context = (require as any).context(`./`, false, /\.json$/);

const enLang = {
  messages: importAllJsonFiles(context),
  antd: antdEN,
  locale: 'en-US',
};

export default enLang;
